import { useState } from 'react';

export default function ProductCategories() {
  const [selectedProduct, setSelectedProduct] = useState<any>(null);

  const scrollToInquiryForm = () => {
    const inquirySection = document.getElementById('product-inquiry');
    if (inquirySection) {
      inquirySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleGetQuote = () => {
    setSelectedProduct(null);
    setTimeout(() => scrollToInquiryForm(), 100);
  };

  const handleContactSales = () => {
    setSelectedProduct(null);
    setTimeout(() => scrollToInquiryForm(), 100);
  };

  const products = [
    {
      category: 'BSF Larvae Products',
      items: [
        {
          name: 'Fresh BSF Larvae',
          description: 'Live larvae for immediate use in animal feed, rich in protein and essential amino acids.',
          fullDescription: 'Our Fresh BSF Larvae are harvested daily to ensure maximum nutritional value and freshness. These live larvae are ideal for farmers and feed producers who want to provide their animals with the highest quality protein source. The larvae are carefully raised in controlled environments using organic waste materials, making them both sustainable and cost-effective.',
          image: 'https://public.readdy.ai/ai/img_res/203f480db602589a14c7628801578b0f.jpg',
          features: ['45-50% Protein', '30% Fat Content', 'Rich in Calcium', 'Live & Fresh'],
          applications: ['Poultry Feed', 'Fish Feed', 'Pet Food', 'Reptile Feed'],
          specifications: {
            'Protein Content': '45-50%',
            'Fat Content': '30%',
            'Moisture': '60-65%',
            'Calcium': '5-8%',
            'Shelf Life': '2-3 days refrigerated'
          },
          benefits: [
            'Maximum nutritional value from live larvae',
            'Natural feeding behavior stimulation',
            'Enhanced animal growth rates',
            'Improved immune system function',
            'Sustainable and eco-friendly protein source'
          ],
          usage: 'Feed fresh larvae directly to animals or mix with regular feed. Recommended feeding rate: 5-10% of total feed weight for poultry, 10-15% for fish, and 15-20% for reptiles.'
        },
        {
          name: 'Dried BSF Larvae',
          description: 'Dehydrated larvae with extended shelf life, perfect for commercial feed production.',
          fullDescription: 'Our Dried BSF Larvae undergo a careful dehydration process that preserves their nutritional content while extending shelf life significantly. This makes them ideal for commercial feed manufacturers, export markets, and farmers who need reliable, long-term storage solutions. The drying process concentrates the protein content, making them even more nutrient-dense than fresh larvae.',
          image: 'https://readdy.ai/api/search-image?query=Dried%20black%20soldier%20fly%20larvae%20in%20storage%20containers%2C%20processed%20insect%20protein%20for%20animal%20feed%2C%20sustainable%20protein%20meal%20production%2C%20dehydrated%20BSF%20larvae%2C%20commercial%20feed%20ingredients%2C%20eco-friendly%20agricultural%20processing&width=400&height=300&seq=dried-larvae&orientation=landscape',
          features: ['60% Protein', 'Extended Shelf Life', 'Easy Storage', 'Bulk Available'],
          applications: ['Commercial Feed', 'Export Markets', 'Aquaculture', 'Livestock Feed'],
          specifications: {
            'Protein Content': '55-60%',
            'Fat Content': '25-30%',
            'Moisture': '&lt;10%',
            'Ash Content': '&lt;8%',
            'Shelf Life': '12 months in cool, dry conditions'
          },
          benefits: [
            'Long shelf life for convenient storage',
            'Concentrated protein content',
            'Easy to transport and handle',
            'Consistent quality year-round',
            'Suitable for automated feed production'
          ],
          usage: 'Mix dried larvae into feed formulations at 5-15% inclusion rate. Can be ground into powder or used whole. Rehydrate if needed for specific applications.'
        }
      ]
    },
    {
      category: 'Processed Products',
      items: [
        {
          name: 'BSF Protein Meal',
          description: 'High-quality protein meal processed from BSF larvae, ideal for premium animal feeds.',
          fullDescription: 'Our BSF Protein Meal is produced through advanced processing techniques that maximize protein concentration while maintaining amino acid profiles. This premium product meets international feed standards and is suitable for export markets. The meal is finely ground for easy incorporation into various feed formulations and provides consistent quality batch after batch.',
          image: 'https://readdy.ai/api/search-image?query=High-quality%20protein%20meal%20powder%20from%20black%20soldier%20fly%20larvae%2C%20processed%20insect%20protein%20for%20animal%20feed%2C%20sustainable%20protein%20processing%20facility%2C%20premium%20feed%20ingredients%2C%20clean%20industrial%20processing%2C%20eco-friendly%20agricultural%20innovation&width=400&height=300&seq=protein-meal&orientation=landscape',
          features: ['65% Protein', 'Low Ash Content', 'Consistent Quality', 'Export Grade'],
          applications: ['Premium Pet Food', 'Aquaculture Feed', 'Poultry Supplements', 'Export Markets'],
          specifications: {
            'Protein Content': '60-65%',
            'Fat Content': '15-20%',
            'Moisture': '&lt;8%',
            'Ash Content': '&lt;6%',
            'Particle Size': '100-500 microns'
          },
          benefits: [
            'Highest protein concentration available',
            'Excellent amino acid profile',
            'Low anti-nutritional factors',
            'Meets international quality standards',
            'Ideal for premium feed formulations'
          ],
          usage: 'Incorporate into feed formulations at 5-20% depending on target species. Suitable for pelleting and extrusion processes. Store in cool, dry conditions.'
        },
        {
          name: 'BSF Oil',
          description: 'Extracted oil from BSF larvae, rich in essential fatty acids for various applications.',
          fullDescription: 'BSF Oil is cold-pressed from larvae to preserve its nutritional properties and natural composition. Rich in lauric acid and other medium-chain fatty acids, this oil has applications in animal nutrition, cosmetics, and industrial uses. Our extraction process ensures high purity and consistent quality, making it suitable for both feed and non-feed applications.',
          image: 'https://readdy.ai/api/search-image?query=BSF%20oil%20extraction%20from%20black%20soldier%20fly%20larvae%2C%20sustainable%20oil%20production%2C%20essential%20fatty%20acids%20for%20animal%20feed%2C%20clean%20processing%20facility%2C%20eco-friendly%20oil%20extraction%2C%20agricultural%20innovation%20in%20Ghana&width=400&height=300&seq=bsf-oil&orientation=landscape',
          features: ['Rich in Omega-3', 'High Quality', 'Multiple Uses', 'Sustainable Source'],
          applications: ['Feed Additive', 'Cosmetics', 'Biodiesel', 'Industrial Uses'],
          specifications: {
            'Lauric Acid': '40-45%',
            'Oleic Acid': '15-20%',
            'Palmitic Acid': '10-15%',
            'Moisture': '&lt;0.5%',
            'Free Fatty Acids': '&lt;2%'
          },
          benefits: [
            'High lauric acid content (antimicrobial properties)',
            'Excellent energy source for animals',
            'Natural and sustainable alternative to palm oil',
            'Multiple industrial applications',
            'Stable at room temperature'
          ],
          usage: 'Add to feed formulations at 1-5% for energy supplementation. For cosmetic use, can be used directly or blended with other oils. Store in sealed containers away from light.'
        }
      ]
    },
    {
      category: 'Organic Fertilizers',
      items: [
        {
          name: 'BSF Frass Fertilizer',
          description: 'Premium organic fertilizer from BSF waste, perfect for sustainable agriculture.',
          fullDescription: 'BSF Frass is the natural byproduct of our larvae production process, consisting of larvae excrement and residual organic matter. This premium organic fertilizer is rich in nitrogen, phosphorus, and potassium, along with beneficial microorganisms that improve soil health. It provides both immediate and slow-release nutrients, making it ideal for sustainable farming practices.',
          image: 'https://readdy.ai/api/search-image?query=Organic%20frass%20fertilizer%20from%20black%20soldier%20fly%20farming%2C%20dark%20rich%20compost%20material%2C%20sustainable%20agricultural%20fertilizer%2C%20eco-friendly%20soil%20amendment%2C%20circular%20economy%20waste%20management%2C%20organic%20farming%20innovation%20in%20Ghana&width=400&height=300&seq=frass-fertilizer-detail&orientation=landscape',
          features: ['100% Organic', 'NPK Rich', 'Improves Soil Health', 'Slow Release'],
          applications: ['Crop Production', 'Horticulture', 'Organic Farming', 'Soil Restoration'],
          specifications: {
            'Nitrogen (N)': '2.5-4%',
            'Phosphorus (P)': '2-3%',
            'Potassium (K)': '1.5-2.5%',
            'Organic Matter': '&gt;60%',
            'pH': '6.5-7.5'
          },
          benefits: [
            'Improves soil structure and water retention',
            'Enhances beneficial microbial activity',
            'Provides balanced NPK nutrition',
            'Reduces need for chemical fertilizers',
            'Safe for organic certification'
          ],
          usage: 'Apply 2-5 tons per hectare for field crops, or 500g-1kg per square meter for gardens. Can be used as top dressing or incorporated into soil before planting. Suitable for all crop types.'
        },
        {
          name: 'Liquid Fertilizer',
          description: 'Concentrated liquid fertilizer derived from BSF processing, easy to apply.',
          fullDescription: 'Our Liquid Fertilizer is produced through a specialized extraction process that captures water-soluble nutrients from BSF frass. This concentrated formula provides rapid nutrient uptake and is perfect for foliar feeding, hydroponics, and situations requiring quick plant response. The liquid form allows for precise application and easy integration into irrigation systems.',
          image: 'https://readdy.ai/api/search-image?query=Liquid%20organic%20fertilizer%20from%20black%20soldier%20fly%20processing%2C%20concentrated%20plant%20nutrients%2C%20sustainable%20agriculture%20solutions%2C%20eco-friendly%20liquid%20fertilizer%20bottles%2C%20organic%20farming%20innovation%2C%20circular%20economy%20waste%20management&width=400&height=300&seq=liquid-fertilizer&orientation=landscape',
          features: ['Fast Acting', 'Easy Application', 'Concentrated Formula', 'Organic Certified'],
          applications: ['Foliar Feeding', 'Hydroponics', 'Greenhouse Growing', 'Quick Nutrition'],
          specifications: {
            'NPK Ratio': '5-3-2',
            'Organic Matter': '15-20%',
            'pH': '6.0-7.0',
            'Concentration': '10x concentrate',
            'Shelf Life': '6 months'
          },
          benefits: [
            'Rapid nutrient absorption through leaves',
            'Ideal for correcting nutrient deficiencies',
            'Easy to mix and apply',
            'Suitable for automated systems',
            'Minimal environmental impact'
          ],
          usage: 'Dilute 1:10 with water for foliar application or 1:20 for soil drench. Apply every 7-14 days during growing season. Can be mixed with other organic inputs.'
        }
      ]
    },
    {
      category: 'Natural Superfoods',
      items: [
        {
          name: 'Pure Moringa Powder',
          description: 'Farm-fresh 100% pure moringa powder, carefully processed to preserve maximum nutrients — a daily wellness essential for families and health professionals.',
          fullDescription: 'Our Pure Moringa Powder is harvested from trees grown right here in Ghana and processed with low-heat methods to ensure all vitamins, minerals, and antioxidants are fully preserved. Free from additives, fillers, or preservatives — just pure moringa as nature intended. Packed with 7× more Vitamin C than oranges, 4× more Calcium than milk, and 3× more Potassium than bananas, it is one of the most nutrient-dense superfoods available. Suitable for daily consumption by all ages.',
          image: 'https://readdy.ai/api/search-image?query=Pure%20organic%20moringa%20powder%20in%20a%20small%20wooden%20bowl%20and%20a%20glass%20jar%20filled%20with%20vibrant%20bright%20green%20powder%2C%20fresh%20moringa%20leaves%20placed%20beside%20the%20bowl%2C%20white%20marble%20background%2C%20natural%20soft%20lighting%20highlighting%20the%20rich%20deep%20green%20color%20of%20the%20superfood%20powder%2C%20clean%20minimalist%20product%20photography%2C%20premium%20health%20supplement%20presentation%2C%20scattered%20moringa%20leaf%20powder%20around%20the%20bowl%2C%20shallow%20depth%20of%20field&width=400&height=300&seq=pure-moringa-powder-product&orientation=landscape',
          features: ['100% Pure & Natural', 'No Additives', 'Low-Heat Processed', 'Locally Grown in Ghana'],
          applications: ['Daily Wellness', 'Smoothies & Juices', 'Soups & Cooking', 'Tea & Beverages'],
          specifications: {
            'Protein Content': '25-30%',
            'Vitamin C': '51.7 mg per 100g',
            'Calcium': '185 mg per 100g',
            'Iron': '28 mg per 100g',
            'Processing': 'Low-heat dried & milled',
            'Additives': 'None — 100% pure',
            'Shelf Life': '24 months sealed',
            'Packaging': 'Available in 50g, 100g, 250g, 1kg'
          },
          benefits: [
            '7× more Vitamin C than oranges — boosts immunity naturally',
            '4× more Calcium than milk — supports strong bones',
            'Rich in Iron — helps combat anaemia',
            'Powerful antioxidants that reduce inflammation',
            'Supports healthy blood sugar and energy levels',
            'Safe for all ages including children and the elderly'
          ],
          usage: 'Add 1–2 teaspoons (3–6g) daily to smoothies, juices, soups, or warm water with honey. Do not boil — add to dishes after cooking to preserve nutrients. Can be taken morning and evening for best results. Store in a cool, dry place away from direct sunlight.'
        }
      ]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Product Range
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            High-quality, sustainable products — from protein-rich BSF larvae and organic fertilizers to our pure Ghanaian moringa powder superfood.
          </p>
        </div>

        {products.map((category, categoryIndex) => (
          <div key={categoryIndex} className="mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
              {category.category}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-product-shop>
              {category.items.map((product, productIndex) => (
                <div key={productIndex} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="h-64 bg-gray-200 overflow-hidden">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <h4 className="text-xl font-semibold text-gray-900 mb-3">
                      {product.name}
                    </h4>
                    <p className="text-gray-600 mb-4">
                      {product.description}
                    </p>
                    
                    <div className="mb-4">
                      <h5 className="font-semibold text-gray-900 mb-2">Key Features:</h5>
                      <div className="flex flex-wrap gap-2">
                        {product.features.map((feature, featureIndex) => (
                          <span 
                            key={featureIndex}
                            className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="mb-6">
                      <h5 className="font-semibold text-gray-900 mb-2">Applications:</h5>
                      <div className="flex flex-wrap gap-2">
                        {product.applications.map((app, appIndex) => (
                          <span 
                            key={appIndex}
                            className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm"
                          >
                            {app}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="flex gap-3">
                      <button 
                        onClick={handleGetQuote}
                        className="flex-1 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Get Quote
                      </button>
                      <button 
                        onClick={() => setSelectedProduct(product)}
                        className="flex-1 border border-gray-300 hover:bg-gray-50 text-gray-700 py-2 px-4 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Product Detail Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setSelectedProduct(null)}>
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <h3 className="text-2xl font-bold text-gray-900">{selectedProduct.name}</h3>
              <button 
                onClick={() => setSelectedProduct(null)}
                className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-6">
              <div className="h-80 bg-gray-200 rounded-lg overflow-hidden mb-6">
                <img 
                  src={selectedProduct.image} 
                  alt={selectedProduct.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Product Overview</h4>
                <p className="text-gray-600 leading-relaxed">{selectedProduct.fullDescription}</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">Technical Specifications</h4>
                  <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                    {Object.entries(selectedProduct.specifications).map(([key, value], index) => (
                      <div key={index} className="flex justify-between items-center border-b border-gray-200 pb-2 last:border-0">
                        <span className="font-medium text-gray-700">{key}:</span>
                        <span className="text-gray-900">{value as string}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">Key Benefits</h4>
                  <ul className="space-y-2">
                    {selectedProduct.benefits.map((benefit: string, index: number) => (
                      <li key={index} className="flex items-start text-gray-600">
                        <i className="ri-check-line text-green-600 mr-2 mt-1 flex-shrink-0"></i>
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Usage Guidelines</h4>
                <p className="text-gray-600 bg-blue-50 rounded-lg p-4 leading-relaxed">{selectedProduct.usage}</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Applications</h4>
                <div className="flex flex-wrap gap-2">
                  {selectedProduct.applications.map((app: string, index: number) => (
                    <span 
                      key={index}
                      className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg font-medium"
                    >
                      {app}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flex gap-4 pt-4 border-t border-gray-200">
                <button 
                  onClick={handleGetQuote}
                  className="flex-1 bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  Request Quote
                </button>
                <button 
                  onClick={handleContactSales}
                  className="flex-1 border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white py-3 px-6 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact Sales Team
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
